import React, { useEffect, useState } from 'react';
import Hero from '../Hero';
import ProblemStatement from '../Problem';
import '../Styles/Safeguard.scss';
import ProxyPNG from '../Styles/safeguard.png';

const Safeguard = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="main-safeguard-container">
      {/* Optional Hero Component preserved */}
      {/* <Hero /> */}

      {/* Section 1: Overview */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Project Overview</h1>
          <div className="main-safeguard-product">
            <h2>The Product</h2>
            <p>
              To provide secure, user-friendly delivery options that minimize package theft and enhance customer trust in e-commerce and delivery services.
            </p>
            <div className="main-project">
              <h2>Project Duration</h2>
              <p>Dec - Jan 2025</p>
            </div>
          </div>
        </div>
        <div className="main-right-section">
          <img src={ProxyPNG} alt="Project Overview visual representation" />
        </div>
      </section>

      {/* Section 2: Problem & Goal */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          {/* <h1>Project Overview</h1> */}
          <div className="main-safeguard-product text-changer">
            <h2 className="text-changer">The Problem</h2>
            <p className="text-changer">
              The project aims to address the issue of package theft, which often occurs when deliveries are left unattended. This involves solving problems related to inadequate delivery security options and improving communication to ensure users can retrieve their packages safely and conveniently.
            </p>
          </div>
        </div>
        <div className="main-right-section text-changer">
          <div className="main-goal-section">
            <h2 className="text-changer">The Goal</h2>
            <p className="text-changer">
              The goal of the project is to enhance delivery security and user trust by minimizing package theft incidents. This involves designing user-centric solutions, such as secure delivery options and improved communication, to ensure a safer and more satisfying delivery experience.
            </p>
          </div>
        </div>
      </section>

      {/* Section 3: Role & Responsibilities */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          {/* <h1>Project Overview</h1> */}
          <div className="main-safeguard-product">
            <h2>My Role</h2>
            <p>
              As the UX designer leading the project, I take ownership of every aspect of the design process, from user research and prototyping to testing and refinement. Leveraging the power of Replit AI, I streamline development, ensure efficiency, and introduce innovative solutions that enhance user experiences while aligning with project goals and objectives.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <h2>Responsibilities</h2>
          <p>
            Conducting interviews, paper and digital wireframing, low and high-fidelity prototyping, conducting usability studies, accounting for accessibility, iterating on designs and responsive design.
          </p>
        </div>
      </section>

      {/* Section 4: Understanding the User */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1>Understanding The User</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="text-changer">
            <h2>User Research</h2>
            <h2>Personas</h2>
            <h2>Problems Statements</h2>
            <h2>User Journey Maps</h2>
          </div>
        </div>
      </section>

      {/* Section 5: User Research Summary */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>User Research: Summary</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p>
              For this project, the user research focused on understanding the root causes and impacts of package theft on user satisfaction and trust. Through surveys and interviews, I gathered insights into user behaviors, preferences, and frustrations regarding delivery experiences. The research highlighted key pain points, such as a lack of secure delivery options, inadequate communication about delivery times, and challenges in resolving theft incidents. These findings were pivotal in shaping user personas and journey maps, which informed actionable design solutions to enhance delivery security and satisfaction.
            </p>
          </div>
        </div>
      </section>

      {/* Section 6: Pain Points */}
      <section className="main-safeguard-content text-changer bg-changer">
        <div className="main-left-section">
          <h1>User Research: Pain Points</h1>
          <div className="main-safeguard-pain-point">
            <h2>Pain Point 1</h2>
            <p>
              Packages left unattended at delivery locations are at high risk of theft, causing frustration for users.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>Pain Point 2</h2>
            <p>
              Users often lack access to secure delivery methods, such as parcel lockers or signature-required deliveries, leaving them with fewer choices to safeguard their packages.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>Pain Point 3</h2>
            <p>
              Inadequate notifications about delivery times or the status of packages make it difficult for users to plan retrieval, increasing the risk of theft.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>Pain Point 4</h2>
            <p>
              Resolving package theft incidents can be time-consuming and unsatisfactory, further compounding user dissatisfaction.
            </p>
          </div>
        </div>
      </section>

      {/* Section 7: Persona */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Persona: David</h1>
          <div className="main-safeguard-product">
            <h2>Problem Statement</h2>
            <p>
              Emily, a working parent, feels anxious about package theft in her neighborhood. She struggles with unreliable delivery options and slow claims processes, leading to frustration and a loss of trust in online shopping. She seeks secure, user-friendly solutions to protect her purchases and maintain peace of mind.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <h2>David Smith</h2>
            <img src={ProxyPNG} alt="User Persona David Smith" />
          </div>
        </div>
      </section>

      {/* Section 8: User Journey Map */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>User Journey Map</h1>
          <div className="main-safeguard-product">
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="User Journey Map visualization" />
          </div>
        </div>
      </section>

      {/* Section 9: Starting the Design */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1>Starting The Design</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="text-changer">
            <h2>Sitemap</h2>
            {/* <h2>Paper Wireframes</h2> */}
            <h2>Digital Wireframes</h2>
            <h2>Low-fidelity Prototype</h2>
            <h2>Usability Studies</h2>
          </div>
        </div>
      </section>

      {/* Commented Out Paper Wireframe Sections preserved */}
      {/* 
      <div className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Paper Wireframes</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="img" />
          </div>
        </div>
      </div> 
      */}

      {/* 
      <div className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1>Paper Wireframes screen size variation(s)</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p className='text-changer'>I drafted iterations of each screen on paper.</p>
            <p className='text-changer'>
              I also started to work on designs for additional screen sizes to make sure the site would be fully responsive.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="img" />
          </div>
        </div>
      </div> 
      */}

      {/* Section 10: Sitemap */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Sitemap</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Sitemap structural diagram" />
          </div>
        </div>
      </section>

      {/* Section 11: Digital Wireframes */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1 className="text-changer">Digital Wireframes</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p className="text-changer">
              Using wireframes, I put my ideas on digital first and then started to make high-fidelity wireframes. After dozens of iterations, these are the wireframes that best represented user flow and met user needs.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Digital Wireframes Preview" />
          </div>
        </div>
      </section>

      {/* Section 12: Wireframe Variations */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Digital Wireframes screen size variations(s)</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Responsive screen variations" />
          </div>
        </div>
      </section>

      {/* Section 13: Low-fidelity Prototype */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1 className="text-changer">Low-fidelity Prototype</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p className="text-changer">
              I created a low-fidelity prototype from the user flow diagram and wireframes to test functionality before incorporating it into final design and ensure accessibility for end-users.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Low-fidelity prototype demonstration" />
          </div>
        </div>
      </section>

      {/* Section 14: Usability Studies */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Usability Study: Findings</h1>
          <div className="main-safeguard-pain-point">
            <h2>Finding 1</h2>
            <p>
              <strong>Need for Flexible Delivery Arrangements:</strong> Features like rescheduling deliveries or providing alternate drop-off instructions were highlighted as essential for improving user convenience and security.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>Finding 2</h2>
            <p>
              <strong>Importance of Real-Time Notifications:</strong> Users wanted more precise, real-time updates about delivery status to better plan package retrieval.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>Finding 3</h2>
            <p>
              <strong>Strong Desire for Secure Delivery Options:</strong> Participants expressed a clear preference for solutions like parcel lockers, smart delivery boxes, or signature-required deliveries to minimize theft risks.
            </p>
          </div>
        </div>
      </section>

      {/* Section 15: Refining The Design */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Refining The Design</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <h2>Mockups</h2>
            <h2>High-fidelity Prototype</h2>
            <h2>Accessibility</h2>
          </div>
        </div>
      </section>

      {/* Section 16: Mockups */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1>Mockups</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p className="text-changer">
              [Your notes about goals and thought process + how you responded to and implemented peer feedback]
            </p>
          </div>
          <img src={ProxyPNG} alt="Design Mockup Overview" />
        </div>
      </section>

      {/* Section 17: Mockup Variations */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Mockup: Original screen size</h1>
          <div className="main-mocks">
            <img src={ProxyPNG} alt="Mockup screen 1" />
            <img src={ProxyPNG} alt="Mockup screen 2" />
            <img src={ProxyPNG} alt="Mockup screen 3" />
            <img src={ProxyPNG} alt="Mockup screen 4" />
          </div>
        </div>
      </section>

      {/* Section 18: High-fidelity Prototype */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1 className="text-changer">High-Fidelity Prototype</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p className="text-changer">
              After finalizing the low-fidelity prototype, I worked on creating the final designs with the goal of making them simple and intuitive. The main color theme I used was blue because it's a very powerful color that symbolizes strength, power, and action. I thought it was very representative of the persona's character.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="High-fidelity interactive prototype preview" />
          </div>
        </div>
      </section>

      {/* Section 19: Accessibility Considerations */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Accessibility Considerations</h1>
          <div className="main-safeguard-pain-point">
            <h2>1</h2>
            <p>
              <strong>Clear and Inclusive Communication:</strong> Ensure that delivery notifications and security options are accessible to users with visual, auditory, or cognitive impairments. Use plain language, screen reader-friendly text, and alternative communication methods (e.g., text-to-speech).
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>2</h2>
            <p>
              <strong>Accessible Delivery Interfaces:</strong> Design delivery apps and websites with accessibility in mind, including features like high-contrast visuals, scalable text, keyboard navigation, and compatibility with assistive technologies.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>3</h2>
            <p>
              <strong>Physical Accessibility of Delivery Solutions:</strong> For secure delivery options like lockers or designated drop-off points, ensure they are physically accessible to users with mobility challenges. This includes appropriate heights, clear pathways, and compliance with ADA standards.
            </p>
          </div>
        </div>
      </section>

      {/* Section 20: Going Forward Overview */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1>Going Forward</h1>
          <div className="main-safeguard-product">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="text-changer">
            <h2>Takeaways</h2>
            <h2>Next Steps</h2>
          </div>
        </div>
      </section>

      {/* Section 21: Takeaways */}
      <section className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Takeaways</h1>
          <div className="main-safeguard-product">
            <h2>Impact</h2>
            <p>
              The key takeaway from this project was the importance of designing secure, user-friendly delivery options that address package theft concerns while prioritizing clear communication and user satisfaction. By focusing on real user pain points, the project demonstrated how thoughtful design can build trust and improve overall experiences.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <h2>What I learned</h2>
            <p>
              From this project, I learned how to address real user pain points by applying empathetic, user-centered design practices. I gained valuable experience in creating secure delivery solutions and enhancing communication to build user trust and satisfaction. Additionally, I deepened my understanding of accessibility and inclusivity, ensuring designs catered to a diverse audience. This project reinforced the power of thoughtful UX design in solving tangible problems and improving overall user experiences.
            </p>
          </div>
        </div>
      </section>

      {/* Section 22: Next Steps */}
      <section className="main-safeguard-content bg-changer">
        <div className="main-left-section">
          <h1>Next Steps</h1>
          <div className="main-safeguard-pain-point">
            <h2 className="text-changer">1</h2>
            <p className="text-changer">
              Conduct usability testing with a larger and more diverse group of users to gather additional insights and refine the solutions.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2 className="text-changer">2</h2>
            <p className="text-changer">
              Engage with delivery services and e-commerce platforms to assess the feasibility of implementing the proposed designs.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2 className="text-changer">3</h2>
            <p className="text-changer">
              Develop a detailed implementation plan and track the real-world impact of the solutions to ensure they effectively address user pain points and improve satisfaction.
            </p>
          </div>
        </div>
      </section>

      {/* Commented Out Contact Section preserved */}
      {/* 
      <div className="main-safeguard-content">
        <div className="main-left-section">
          <h1>Let's connect</h1>
          <div className="main-safeguard-pain-point">
            <h2>Feedback</h2>
            <p>
              I would appreciate your thoughts and insights on this topic, as feedback is crucial to further enhancing the findings of this study.
            </p>
          </div>
          <div className="main-safeguard-pain-point">
            <h2>Email</h2>
            <p>estelo2jz@gmail.com</p>
          </div>
        </div>
      </div> 
      */}

      {/* Scroll Button */}
      {showScrollButton && (
        <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
          ↑ Top
        </button>
      )}
    </div>
  );
};

export default Safeguard;